<template>
	<div>
		<template v-if="type == 'mobile'">
			<div class="pt-4 border-semi-grey radius-12">
				<div class="px-3 mb-3 text-center">
					<p class="heading-6 mb-0">{{data.merchant_pos.tagline}}</p>
	    		<p class="body-2-2-1 mb-2">{{data.merchant_pos.sub_tagline}}</p>
	    		<div class="w-100 text-center mb-2">
	    			<div class="d-inline-block align-middle border-semi-grey radius-12 px-2 mr-2" v-if="data.merchant_pos.star != null">
	    				<img src="../../../assets/img/icon/hotel-star.png" class="d-inline-block aling-middle" width="14" style="margin-top:-5px !important;">
	    				<p class="mb-0 body-2-1 d-inline-block aling-middle">{{data.merchant_pos.star}}</p>
	    			</div>
	    			<div class="d-inline-block align-middle border-semi-grey radius-12 px-2" v-if="data.merchant_pos.category != null">
	    				<p class="mb-0 body-2-1">{{data.merchant_pos.category}}</p>
	    			</div>
	    		</div>
	    		<div class="w-100 text-center mb-2" v-if="data.merchant_pos.time_start != null && data.merchant_pos.time_end != null">
	          <img src="../../../assets/img/icon/time-dark.png" class="d-inline-block mr-1" width="16">
	          <p class="mb-0 body-1-2 font-regular d-inline-block">Open <svg width="3" height="3" viewBox="0 0 3 3" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="3" height="3" rx="1.5" fill="#222222"/></svg> {{formatTime(data.merchant_pos.time_start)}} - {{formatTime(data.merchant_pos.time_end)}}</p>
	        </div>
	        <div class="w-100 text-center mb-2" v-if="data.custom_data.use_kilos || data.custom_data.use_unit">
	          <img src="../../../assets/img/icon/buy.png" class="d-inline-block mr-1" width="16">
	          <p class="mb-0 body-1-2 font-regular d-inline-block"><template v-if="data.custom_data.use_kilos">Per Kilo</template> <svg v-if="use_both_service" width="3" height="3" viewBox="0 0 3 3" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="3" height="3" rx="1.5" fill="#222222"/></svg> <template v-if="data.custom_data.use_unit">{{$t('hotel.concierge.fitur.laundry.per-pcs')}}</template></p>
	        </div>
				</div>
        <div class="w-100  position-relative">
					<div class="w-100 mb-3" v-if="data.merchant_pos.slider.length == 1" style="height: 189px !important;">
	          <img :src="data.merchant_pos.slider[0].image_url" class="img-fit radius-12-b" height="189">
	        </div>
	    		<flickity v-if="data.merchant_pos.slider.length > 1" ref="flickity" :options="$fullSliderOption">
			      <div class="carousel-cell w-100" :id="slide.id" v-for="slide in  data.merchant_pos.slider">
			        <div class="w-100" style="height: 189px !important;">
			          <img :src="slide.image_url" class="img-fit radius-12-b" height="189">
			        </div>
			      </div>
			    </flickity>
			    <div class="py-2 px-3 border-semi-grey radius-6 d-table position-absolute bg-white" @click="goToDetail" style="bottom:12px;right:12px;">
			    	<p class="mb-0 text-green body-2 d-inline-block aling-middle">{{$t('hotel.concierge.fitur.laundry.laundry-with-us')}}</p>
        		<i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-12 text-green"></i>
			    </div>
			  </div>
			</div>
		</template>
		<template v-if="type == 'desktop'">
			<div class="border-semi-grey radius-12">
    		<div class="row">
    			<div class="col-6">
    				<div class="px-4 pt-3">
	    				<p class="heading-6 mb-0 text-semi-dark">{{data.merchant_pos.tagline}}</p>
			    		<p class="body-2-2-1 mb-1 text-truncate">{{data.merchant_pos.sub_tagline}}</p>
			    		<div class="w-100 mb-3">
			    			<div class="d-inline-block align-middle border-semi-grey radius-12 px-2 mr-2" v-if="data.merchant_pos.star != null">
			    				<img src="../../../assets/img/icon/hotel-star.png" class="d-inline-block aling-middle" width="14" style="margin-top:-5px !important;">
			    				<p class="mb-0 body-2-1 d-inline-block aling-middle">{{data.merchant_pos.star}}</p>
			    			</div>
			    			<div v-if="data.merchant_pos.category" class="d-inline-block align-middle border-semi-grey radius-12 px-2">
			    				<p class="mb-0 body-2-1">{{data.merchant_pos.category}}</p>
			    			</div>
			    		</div>
			    		<div class="w-100 mb-2" v-if="data.merchant_pos.time_start != null && data.merchant_pos.time_end != null">
			          <img src="../../../assets/img/icon/time-dark.png" class="d-inline-block mr-1" width="14">
			          <p class="mb-0 body-1-2 font-medium d-inline-block text-15">Open <svg width="3" height="3" viewBox="0 0 3 3" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="3" height="3" rx="1.5" fill="#222222"/></svg> {{formatTime(data.merchant_pos.time_start)}} - {{formatTime(data.merchant_pos.time_end)}}</p>
			        </div>
			        <div class="w-100" v-if="data.custom_data.use_kilos || data.custom_data.use_unit">
			          <img src="../../../assets/img/icon/buy.png" class="d-inline-block mr-1" width="14">
			          <p class="mb-0 body-1-2 font-medium d-inline-block text-15"><template v-if="data.custom_data.use_kilos">{{$t('hotel.concierge.fitur.laundry.per-kilo')}}</template> <svg v-if="use_both_service" width="3" height="3" viewBox="0 0 3 3" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="3" height="3" rx="1.5" fill="#222222"/></svg> <template v-if="data.custom_data.use_unit">{{$t('hotel.concierge.fitur.laundry.per-pcs')}}</template></p>
			        </div>
			      </div>
    			</div>
    			<div class="col-6">
    				<div class="w-100 position-relative" style="height:189px;">
							<div class="w-100 mb-3" v-if="data.merchant_pos.slider.length == 1" style="height: 189px !important;">
			          <img :src="data.merchant_pos.slider[0].image_url" class="img-fit radius-12-r" height="189">
			        </div>
			        <flickity ref="flickity" v-else :options="$fullSliderOption">
					      <div class="carousel-cell w-100" :id="slide.id" v-for="slide in  data.merchant_pos.slider">
					        <div class="w-100" style="height: 189px !important;">
					          <img :src="slide.image_url" class="img-fit radius-12-r" height="189">
					        </div>
					      </div>
					    </flickity>
							<div class="py-2 px-3 border-semi-grey radius-6 d-table position-absolute bg-white" @click="goToDetail" style="bottom:12px;right:12px;">
					    	<p class="mb-0 text-green body-2 d-inline-block aling-middle">{{$t('hotel.concierge.fitur.laundry.laundry-with-us')}}</p>
		        		<i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-12 text-green"></i>
					    </div>
			    	</div>
    			</div>
    		</div>
    	</div>
		</template>
	</div>
</template>
<script>
  import Flickity from 'vue-flickity';
  import {mapGetters} from 'vuex'
  import moment from 'moment'

	export default{
		props:['type','data'],
		components:{
			Flickity
		},
		computed:{
			...mapGetters(['getMerchant']),
			use_both_service(){
				return this.data.custom_data.use_kilos && this.data.custom_data.use_unit ? true : false
			}
		},
		methods:{
			goToDetail(){
				this.$postLog('HOME','MODULE PREVIEW',`Clicked detail ${this.data.merchant_pos.code}`)
				this.$router.push(`/${this.getMerchant.code}/concierge/laundry`)
			},
			formatTime(time){
				return moment(time,'HH:mm:ss').format("HH:mm")
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/general/LaundryPreview.vue